import React, { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { BackToClickBiEvent, BiData } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowLeft from '@wix/da-ds/pkg/Icons/ArrowLeft';
import { getBasicBiDataForDuperItem } from '../../../Duperbrowse/redux/helpers';
import { getCurrentItem } from '../../../Duperbrowse/redux/selectors';
import { getStashFolder } from '../../../DeviationPage/redux/selectors';
import s from './BackToStashButton.scss';

export interface Props {
  className?: string;
}

const BackToStashButton: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  const isMobile = useContext(MobileContext);
  const currentItem = useSelector(getCurrentItem);
  const folder = useSelector(getStashFolder);

  const openStash = useCallback(() => {
    if (folder && folder.folderId) {
      window.location.assign(Url.stashFolderLink(folder.folderId));
    }
  }, [folder]);

  if (!folder || !folder.folderId) {
    return null;
  }

  return (
    <TextButton
      icon={ArrowLeft}
      variant="main"
      size="small"
      className={classnames(s['duperexit'], className)}
      onClick={openStash}
      noHorizontalPaddings={isMobile}
      biData={
        currentItem &&
        BiData<BackToClickBiEvent>({
          evid: 304,
          ...getBasicBiDataForDuperItem(currentItem),
        })
      }
      aria-label={t('deviation.stash.backToStash')}
    >
      {!isMobile && t('deviation.stash.backToStash')}
    </TextButton>
  );
};

BackToStashButton.displayName = 'BackToStashButton';

export default BackToStashButton;
